import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="extract-image-urls"
export default class extends Controller {
  static targets = ["input", "prefix", "output", "resultCount"]

  extract() {
    let result = new Set([])

    console.log(this.inputTarget.value)

    let DOMParsing = new DOMParser();
    let parsed = DOMParsing.parseFromString(this.inputTarget.value, "text/html");
    parsed.querySelectorAll("img").forEach(img => {
      if (!img.src.includes("data:image")) {
        let src = img.getAttribute("src")
        if (this.prefixTarget.value && !src.startsWith("http")) {
          src = src.startsWith("/") ? this.prefixTarget.value + src : this.prefixTarget.value + "/" + src
        }
        result.add(src)
      }
    });

    switch (result.size) {
      case 0:
        this.resultCountTarget.textContent = "No images found."
        break;
      case 1:
        this.resultCountTarget.textContent = "1 image found."
        break;
      default:
        this.resultCountTarget.textContent = `${result.size} images found.`
    }
    this.outputTarget.value = Array.from(result).join("\n")
  }
}
